import { useEffect, useRef, useState } from 'react';

export const usePromise = <T>(p: Promise<T>): T | undefined => {
  const [value, setValue] = useState<T>();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleValueChange = (v: T) => {
    if (isMounted.current) {
      setValue(v);
    }
  };

  useEffect(() => {
    p.then(handleValueChange).catch(error => console.error(error));
  }, []);

  return value;
};
